<!-- Barra de ações -->
<div class="po-row po-mb-3 po-pt-4">
  <div class="po-sm-12 po-md-4 po-lg-3">
    <po-button
      p-label="Nova Extração"
      p-kind="primary"
      p-icon="po-icon-upload"
      (p-click)="openExtractModal()"
    ></po-button>
  </div>
</div>

<!-- Filtros -->
<div class="filter-row">
  <po-datepicker-range
    class="filter-field"
    name="filterPeriod"
    p-label="Período"
    [(ngModel)]="filterPeriod"
    (p-change)="onFilterChange()"
    p-size="small"
  ></po-datepicker-range>

  <po-select
    class="filter-field"
    name="filterStatus"
    p-label="Status"
    [(ngModel)]="filterStatus"
    [p-options]="filterStatusOptions"
    (p-change)="onFilterChange()"
  ></po-select>

  <div class="filter-actions">
    <po-button
      p-label="Atualizar"
      p-kind="secondary"
      p-icon="po-icon-refresh"
      [p-loading]="loading"
      (p-click)="loadRuns()"
    ></po-button>
  </div>
</div>

<div class="filter-export-row">
  <po-button
    p-label="CSV"
    p-kind="secondary"
    p-icon="po-icon-export"
    [p-loading]="exportingCsv"
    [p-disabled]="runs.length === 0"
    (p-click)="exportCsv()"
  ></po-button>
</div>

<!-- Tabela -->
<po-table
  [p-columns]="tableColumns"
  [p-items]="runs"
  [p-loading]="loading"
  [p-sort]="true"
  [p-actions]="tableActions"
  [p-show-more-disabled]="!hasMoreRuns"
  [p-literals]="{ noData: 'Nenhuma execução encontrada', showMore: 'Carregar mais' }"
  (p-show-more)="loadMoreRuns()"
></po-table>

<!-- Modal: Nova Extração -->
<po-modal
  #modalExtract
  p-title="Iniciar Nova Extração"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction"
>
  <po-textarea
    name="excludeProjectsRaw"
    p-label="Padrões de projetos a ignorar (um por linha)"
    p-rows="4"
    [(ngModel)]="excludeProjectsRaw"
  ></po-textarea>

  <po-info
    p-label="Dica"
    p-value="Use % como a instrução LIKE do SQL. Ex: 'BSO%' ignora todos os projetos que começam com BSO. Máximo de 20 padrões."
  ></po-info>
</po-modal>

<!-- Modal: Detalhes da Execução -->
<po-modal
  #modalDetail
  p-title="Detalhes da Execução"
  p-size="lg"
  [p-primary-action]="modalDetailCloseAction"
>
  <ng-container *ngIf="selectedRun">
    <po-table
      class="no-header-table"
      [p-items]="runDetailItems"
      [p-hide-columns-manager]="true"
      [p-striped]="true"
    ></po-table>

    <ng-container *ngIf="selectedRun.status === 'FAILED' && selectedRun.error_message">
      <po-divider p-label="Mensagem de Erro"></po-divider>
      <div class="run-error-block">
        <span class="po-icon po-icon-close run-error-icon"></span>
        <p class="run-error-message">{{ selectedRun.error_message }}</p>
      </div>
    </ng-container>
  </ng-container>
</po-modal>
